<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  created() {},
};
</script>
<style lang="less" scoped>
#app {
  height: 100vh;
  width: 100vw;
}
</style>